import {
    logEmailInsightClicked,
    logFileInsightClicked,
    logEventInsightClicked,
} from './instrumentationHelpers';
import type {
    EmailInsightType,
    FileInsightType,
    InsightsDataFetchSource,
    EventInsightType,
} from 'owa-meeting-insights-types-and-flights';
import type { ReadingPaneEntrySourceType } from 'owa-calendar-helpers-types/lib/ReadingPaneEntrySourceType';
import { popoutReadingPane } from 'owa-popout';
import { getUserMailboxInfo } from 'owa-client-ids';
import { getOpxHostApi } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isMailCapabilitySupported, lazyOpenMailItem } from 'owa-metaos-app-bootstrap';

export function openEmailInsight(
    meetingId: string,
    email: EmailInsightType,
    readingPaneEntrySource: ReadingPaneEntrySourceType | null,
    insightsEntrySource: InsightsDataFetchSource
) {
    const { itemId, reactDeeplinkUrl } = email;
    if (itemId) {
        const defaultCallback = () =>
            popoutReadingPane(itemId, null /*conversationId*/, getUserMailboxInfo());
        if (isHostAppFeatureEnabled('processMeetingInsightsHandler')) {
            getOpxHostApi().processMeetingInsightsCallback(
                'openEmailInsight',
                {
                    itemId,
                },
                defaultCallback
            );
        } else if (isHostAppFeatureEnabled('openMailInHub') && isMailCapabilitySupported()) {
            lazyOpenMailItem.importAndExecute(itemId);
        } else {
            defaultCallback();
        }
    } else if (reactDeeplinkUrl) {
        window.open(reactDeeplinkUrl);
    }

    logEmailInsightClicked(meetingId, email, readingPaneEntrySource, insightsEntrySource);
}

export function openFileInsight(
    meetingId: string,
    file: FileInsightType,
    readingPaneEntrySource: ReadingPaneEntrySourceType | null,
    insightsEntrySource: InsightsDataFetchSource
) {
    const { reactDeeplinkUrl, fileUrl, fileExtension } = file;
    const defaultCallback = () => window.open(reactDeeplinkUrl);
    if (isHostAppFeatureEnabled('processMeetingInsightsHandler')) {
        getOpxHostApi().processMeetingInsightsCallback(
            'openFileInsight',
            {
                fileUrl,
                fileExtension,
                webUrl: reactDeeplinkUrl,
            },
            defaultCallback
        );
    } else {
        defaultCallback();
    }
    logFileInsightClicked(meetingId, file, readingPaneEntrySource, insightsEntrySource);
}

export function openEventInsight(
    meetingId: string,
    event: EventInsightType,
    readingPaneEntrySource: ReadingPaneEntrySourceType | null,
    insightsEntrySource: InsightsDataFetchSource
) {
    const { itemId, reactDeeplinkUrl } = event;
    if (itemId) {
        const defaultCallback = () => popoutReadingPane('calendar', itemId);
        if (isHostAppFeatureEnabled('processMeetingInsightsHandler')) {
            getOpxHostApi().processMeetingInsightsCallback(
                'openEventInsight',
                {
                    itemId,
                },
                defaultCallback
            );
        } else {
            defaultCallback();
        }
    } else if (reactDeeplinkUrl) {
        window.open(reactDeeplinkUrl);
    }

    logEventInsightClicked(meetingId, event, readingPaneEntrySource, insightsEntrySource);
}
